import {Component, Input} from '@angular/core';
import {ApplicationEnum} from "@Common/widgets/general/attachments/interfaces/application.enum";
import {Loaning} from "../../common/services/loaning/loaning.model";


@Component({
  selector: 'app-dialogues',
  templateUrl: './dialogues.component.html',
  styleUrls: ['./dialogues.component.scss']
})
export class DialoguesComponent {
  @Input() Loaning: Loaning = <Loaning>{};
  @Input() emails= [];
  application: ApplicationEnum = ApplicationEnum.archivage;
}
